/**
 * [amaflow] #4 — Dynamische Cart Cross-Sells / Up-Sells
 * Custom Element das automatisch Komplementärprodukte lädt.
 */
if (!window.customElements.get('amaflow-cart-recs')) {
  window.customElements.define('amaflow-cart-recs', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.amaflow-cart-recs__list');
      if (this.list) this.load();
    }

    async load() {
      try {
        const cartResponse = await fetch(Shopify.routes.root + 'cart.js');
        const cart = await cartResponse.json();

        if (!cart.items || cart.items.length === 0) {
          this.removeAttribute('data-loaded');
          return;
        }

        const cartProductIds = new Set(cart.items.map(item => item.product_id));
        const allRecs = [];
        const seenIds = new Set();

        for (let i = 0; i < Math.min(cart.items.length, 3); i++) {
          const recs = await this.fetchRecs(cart.items[i].product_id);
          for (const rec of recs) {
            if (!cartProductIds.has(rec.id) && !seenIds.has(rec.id) && rec.available) {
              seenIds.add(rec.id);
              allRecs.push(rec);
            }
            if (allRecs.length >= 3) break;
          }
          if (allRecs.length >= 3) break;
        }

        this.list.innerHTML = '';

        if (allRecs.length === 0) {
          this.removeAttribute('data-loaded');
          return;
        }

        const formatter = new Intl.NumberFormat(Shopify.locale, {
          style: 'currency',
          currency: Shopify.currency.active
        });

        allRecs.forEach(product => {
          this.list.appendChild(this.renderCard(product, formatter));
        });

        this.setAttribute('data-loaded', '');
      } catch (e) {
        this.removeAttribute('data-loaded');
      }
    }

    async fetchRecs(productId) {
      try {
        let response = await fetch(
          Shopify.routes.root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=complementary'
        );
        let data = await response.json();
        if (data.products && data.products.length > 0) return data.products;

        response = await fetch(
          Shopify.routes.root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related'
        );
        data = await response.json();
        return data.products || [];
      } catch (e) {
        return [];
      }
    }

    renderCard(product, formatter) {
      const price = formatter.format(product.price / 100);
      const image = product.featured_image
        ? product.featured_image.replace(/(\.[^.]+)$/, '_200x200$1')
        : '';
      const variantId = product.variants[0].id;

      const card = document.createElement('div');
      card.className = 'amaflow-rec-card';
      card.innerHTML =
        (image
          ? '<img class="amaflow-rec-card__image" src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="64" height="64">'
          : '<div class="amaflow-rec-card__image"></div>') +
        '<div class="amaflow-rec-card__info">' +
          '<a href="' + product.url + '" class="amaflow-rec-card__title">' + product.title + '</a>' +
          '<span class="amaflow-rec-card__price">' + price + '</span>' +
        '</div>' +
        '<button class="amaflow-rec-card__add" data-variant-id="' + variantId + '">+ Hinzufügen</button>';

      card.querySelector('.amaflow-rec-card__add').addEventListener('click', async function() {
        const btn = this;
        btn.disabled = true;
        btn.textContent = '…';

        try {
          const response = await fetch(Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId), quantity: 1 }] })
          });

          if (response.ok) {
            btn.textContent = '✓';
            card.style.opacity = '0.5';
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } else {
            btn.textContent = 'Fehler';
            setTimeout(() => { btn.textContent = '+ Hinzufügen'; btn.disabled = false; }, 2000);
          }
        } catch (e) {
          btn.textContent = 'Fehler';
          setTimeout(() => { btn.textContent = '+ Hinzufügen'; btn.disabled = false; }, 2000);
        }
      });

      return card;
    }
  });
}
